module.exports = __webpack_public_path__ + "static/media/p3_8.a03d2977.png";